import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VSheet,
    { staticClass: "text-center" },
    [
      _c("div", { staticClass: "text-caption text-right" }, [
        _vm.processDirection == "Input"
          ? _c("span", [
              _vm._v(_vm._s(_vm.$vuetify.lang.t("$vuetify.worksheet.in"))),
            ])
          : _vm._e(),
        _vm.processDirection == "Output"
          ? _c("span", [
              _vm._v(_vm._s(_vm.$vuetify.lang.t("$vuetify.worksheet.out"))),
            ])
          : _vm._e(),
      ]),
      _c(
        "div",
        {
          staticClass: "d-flex justify-center my-2",
          style: `font-size: ${_vm.headerFontSize}px`,
        },
        [
          _vm.processType
            ? _c("div", [_vm._v(" " + _vm._s(_vm.processType.name) + " ")])
            : _vm._e(),
          _vm.product && _vm.processType
            ? _c(VDivider, { staticClass: "mx-3", attrs: { vertical: "" } })
            : _vm._e(),
          _vm.product
            ? _c("div", [_vm._v(" " + _vm._s(_vm.product.name) + " ")])
            : _vm._e(),
          _vm.location
            ? _c(VDivider, { staticClass: "mx-3", attrs: { vertical: "" } })
            : _vm._e(),
          _vm.location
            ? _c("div", [_vm._v(" " + _vm._s(_vm.location.name) + " ")])
            : _vm._e(),
        ],
        1
      ),
      _c("qriously", { attrs: { value: _vm.qrCodeUrl, size: _vm.qrSize } }),
      _vm.memo
        ? _c("div", { style: `font-size: ${_vm.memoFontSize}px` }, [
            _vm._v(" " + _vm._s(_vm.memo) + " "),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }